import Modal from "react-bootstrap/Modal";
import {useContext} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import moment from "moment-timezone";
import "moment-timezone";

import AuthContext from "context/AuthContext";
import AssetBasic from "site-apps/assets/components/AssetBasic";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";
import IconCardForLevel from "./IconCardForLevel";

const ModalListUnloads = ({show, setShow, item, date}) => {
    const {org} = useContext(AuthContext);
    const {t: _TC} = useCustomTranslation(translations);
    const unloads = item.unloads[date.date] || [];

    const handleClose = () => {
        setShow(false);
    };

    const getHour = (unload_) => {
        if (!unload_ || !unload_.time) return "";
        const dateTimeUTC = moment.utc(`${unload_.date}T${unload_.time}.000Z`);
        const dateTimeTZ = dateTimeUTC.tz(org?.timezone || "Europe/Madrid");
        return dateTimeTZ.format("HH:mm");
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} animation={true} aria-modal={true} centered={true}>
                <Modal.Header closeButton className="preview-canvas mb-0">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="truck-field" />
                    </div>
                    <div className="preview-title">
                        <Modal.Title className="d-inline">{_TC("unloads")}</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <div className="col-12 d-flex justify-content-center">
                            <AssetBasic asset={item} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 d-flex justify-content-center mb-3">
                            <h4>
                                {_TC("day")}: {date.date}
                            </h4>
                        </div>
                        <div className="col-12 mb-3">
                            <table className="table table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">{_TC("level")}</th>
                                        <th scope="col">{_TC("hour")}</th>
                                        <th>%</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {unloads.map((unload) => (
                                        <tr key={unload.timestamp}>
                                            <td className="list-unloads">
                                                <div className="data-level">
                                                    <IconCardForLevel level={unload.level} />
                                                </div>
                                            </td>
                                            <td>{getHour(unload)}</td>
                                            <td>{unload.value}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-12">
                        <div className="row d-flex justify-content-between">
                            <div className="col text-end">
                                <button type="button" className="btn btn-secondary" onClick={handleClose}>
                                    {_TC("close")}
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModalListUnloads;
